(() => {
  if (window.__okendoFeaturedReviewInit) return;
  window.__okendoFeaturedReviewInit = true;

  const API_ROOT = 'https://api.okendo.io/v1/stores';
  const MONTHS = [
    'January', 'February', 'March', 'April', 'May', 'June',
    'July', 'August', 'September', 'October', 'November', 'December'
  ];

  const STAR_PATH = 'm6.5 0 1.607 4.623 4.893.1-3.9 2.956 1.417 4.685L6.5 9.568l-4.017 2.796L3.9 7.679 0 4.723l4.893-.1L6.5 0Z';

  const buildStars = (value) => {
    const ns = 'http://www.w3.org/2000/svg';
    const rounded = Math.round(value * 2) / 2;
    const fragment = document.createDocumentFragment();

    for (let i = 1; i <= 5; i += 1) {
      const opacity = rounded >= i ? '1' : rounded >= i - 0.5 ? '0.65' : '0.3';
      const svg = document.createElementNS(ns, 'svg');
      svg.setAttribute('aria-hidden', 'true');
      svg.setAttribute('focusable', 'false');
      svg.setAttribute('viewBox', '0 0 13 13');
      const path = document.createElementNS(ns, 'path');
      path.setAttribute('fill', 'currentColor');
      path.setAttribute('fill-opacity', opacity);
      path.setAttribute('d', STAR_PATH);
      svg.appendChild(path);
      fragment.appendChild(svg);
    }

    return fragment;
  };

  const ENTITIES = {
    '&amp;': '&',
    '&quot;': '"',
    '&apos;': "'",
    '&#39;': "'",
    '&lt;': '<',
    '&gt;': '>',
    '&nbsp;': ' '
  };

  const sanitize = (value) => {
    if (!value) return '';
    return value
      .replace(/\\[rnt]/g, ' ')
      .replace(/&(?:amp|quot|apos|#39|lt|gt|nbsp);/gi, (match) => ENTITIES[match.toLowerCase()] || match)
      .replace(/\s+/g, ' ')
      .trim();
  };

  const cleanTitle = (value) => sanitize(value).replace(/([a-z])Review$/, '$1 Review');

  const ordinal = (n) => {
    const suffixes = ['th', 'st', 'nd', 'rd'];
    const remainder = n % 100;
    return n + (suffixes[(remainder - 20) % 10] || suffixes[remainder] || suffixes[0]);
  };

  const formatDate = (iso) => {
    const date = new Date(iso);
    if (Number.isNaN(date.getTime())) return '';
    return `${MONTHS[date.getUTCMonth()]} ${ordinal(date.getUTCDate())}, ${date.getUTCFullYear()}`;
  };

  const truncate = (text, max) => {
    if (!max || text.length <= max) return text;
    const cut = text.slice(0, max);
    const lastSpace = cut.lastIndexOf(' ');
    return `${cut.slice(0, lastSpace > 0 ? lastSpace : max).replace(/[\s.,;:!?-]+$/, '')}...`;
  };

  const pickReview = (reviews) => {
    const eligible = reviews.filter((review) => {
      return review.rating === 5 && review.body && review.body.trim() && review.title && review.title.trim();
    });
    if (!eligible.length) return null;
    return eligible[Math.floor(Math.random() * eligible.length)];
  };

  const fetchReview = async (storeId, productId) => {
    const endpoint = `${API_ROOT}/${storeId}/products/shopify-${productId}/reviews?limit=25&orderBy=${encodeURIComponent('rating desc')}`;
    const response = await fetch(endpoint, { headers: { Accept: 'application/json' } });
    if (!response.ok) return null;
    const payload = await response.json();
    return pickReview(Array.isArray(payload.reviews) ? payload.reviews : []);
  };

  const render = (root, review) => {
    const maxChars = parseInt(root.dataset.maxChars, 10) || 0;
    const rating = root.querySelector('[data-oke-featured-rating]');
    const title = root.querySelector('[data-oke-featured-title]');
    const quote = root.querySelector('[data-oke-featured-quote]');
    const attribution = root.querySelector('[data-oke-featured-attribution]');

    if (rating && review.rating) {
      rating.replaceChildren(buildStars(review.rating));
      rating.hidden = false;
    }

    if (title) title.textContent = cleanTitle(review.title);

    if (quote) {
      const body = sanitize(review.body);
      const paragraph = document.createElement('p');
      paragraph.textContent = `“${truncate(body, maxChars)}”`;
      quote.replaceChildren(paragraph);
    }

    if (attribution) {
      const name = review.reviewer && review.reviewer.displayName ? review.reviewer.displayName.trim() : '';
      const date = formatDate(review.dateCreated);
      attribution.textContent = [name, date].filter(Boolean).join(' | ');
    }
  };

  const reveal = (root) => {
    delete root.dataset.okeFeaturedLoading;
    root.hidden = false;
  };

  const dismiss = (root) => {
    delete root.dataset.okeFeaturedLoading;
    root.hidden = true;
  };

  const activate = async (root) => {
    if (root.dataset.okeFeaturedReady) return;
    root.dataset.okeFeaturedReady = 'true';

    const { storeId, productId } = root.dataset;
    const hasFallback = root.dataset.hasFallback === 'true';

    if (!storeId || !productId) {
      if (hasFallback) reveal(root);
      else dismiss(root);
      return;
    }

    try {
      const review = await fetchReview(storeId, productId);
      if (review) {
        render(root, review);
        reveal(root);
        return;
      }
    } catch (error) {
      if (window.Shopify && window.Shopify.designMode) console.warn('Okendo featured review:', error);
    }

    if (hasFallback) reveal(root);
    else dismiss(root);
  };

  const scan = () => {
    document.querySelectorAll('[data-oke-featured-review]').forEach(activate);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }

  document.addEventListener('shopify:section:load', scan);
  document.addEventListener('shopify:block:select', scan);
})();
